<button type="button" class="btn btn-primary" id="openContactUsModal" [hidden]="true" data-toggle="modal" data-target="#contactUsModal"
  data-backdrop="static" data-keyboard="false" data-dismiss="modal">Hidden
  Btn</button>

<div class="modal" id="contactUsModal" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static">
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="accIdsTitle" style="line-height: 20px;">
          Contact Us
        </h5>
        <button type="button" id="closeContactUsModal" (click)="cancelClicked()" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form #contactUsForm="ngForm" novalidate (ngSubmit)="saveClicked(contactUsForm)">
        <div class="modal-body pt-1">
          <div class="form-group">
            <label><span class="maroon astrisk">&#10033;&nbsp;</span>Name</label>
            <input type="text" class="form-control" placeholder="Name" [(ngModel)]="contactUsModel.name" name="name"
              #name="ngModel" required [readonly]="loggedInUser">
            <small class="text-danger text-center" *ngIf="name.errors && contactUsForm.submitted">
              <p class="mb-0" *ngIf="email.errors.required">*required</p>
            </small>
          </div>
          <div class="form-group">
            <label><span class="maroon astrisk">&#10033;&nbsp;</span>Email</label>
            <input type="email" class="form-control" placeholder="Email" [(ngModel)]="contactUsModel.email" name="email"
              #email="ngModel" required [readonly]="loggedInUser" email>
            <small class="text-danger text-center" *ngIf="email.errors && contactUsForm.submitted">
              <p class="mb-0" *ngIf="email.errors.required">*required</p>
              <p class="mb-0" *ngIf="!email.errors.required">Please provide valid email</p>
            </small>
          </div>          
          <div class="form-group">
            <label>Phone</label>
            <input type="text" class="form-control" placeholder="+1XXXXXXXXXX" pattern="[+][1][0-9]{10}" [(ngModel)]="contactUsModel.phone" name="phone"
              maxlength="12" #phone="ngModel" [readonly]="loggedInUser">
            <small class="text-danger text-center" *ngIf="phone.errors && contactUsForm.submitted">
              <p class="mb-0" *ngIf="!phone.errors.required">Invalid Phone</p>
            </small>
          </div>
          <div class="form-group">
            <label><span class="maroon astrisk">&#10033;&nbsp;</span>Subject</label>
            <input type="text" placeholder="Subject" class="form-control" [(ngModel)]="contactUsModel.subject" name="subject"
              #subject="ngModel" required>
            <small class="text-danger text-center" *ngIf="subject.errors && contactUsForm.submitted">
              <p class="mb-0" *ngIf="subject.errors.required">*required</p>
            </small>
          </div>
          <div class="form-group">
            <label><span class="maroon astrisk">&#10033;&nbsp;</span>Message</label>
            <textarea class="form-control" rows="6" placeholder="Message" [(ngModel)]="contactUsModel.message" name="message"
              #message="ngModel" required></textarea>
            <small class="text-danger text-center" *ngIf="message.errors && contactUsForm.submitted">
              <p class="mb-0" *ngIf="message.errors.required">*required</p>
            </small>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light btn-80" (click)="cancelClicked()" data-dismiss="modal" aria-label="Close">Cancel</button>
          <button type="submit" class="btn btn-primary border btn-80">OK</button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Confirmation Model -->
<div class="modal fade" id="confirmationModel" tabindex="-1" role="dialog" aria-hidden="true">
  <!-- modal-sm -->
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <!-- <h5 class="modal-title" id="confirmTitle"> Confirmation </h5> -->
        <button id="closeConfirmationModel" type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body fix-height-20 d-flex justify-content-center">
        <div class="align-self-center text-center">Thank you for contacting us. We will get back to you at the earliest.</div>
      </div>
    </div>
  </div>
</div>
<button type="button" class="btn btn-primary" id="openConfirmationModel" [hidden]="true" data-toggle="modal"
  data-target="#confirmationModel" data-backdrop="static" data-keyboard="false">Hidden Btn</button>